(() => {
  if (customElements.get('apparel-size-guide')) return;

  class ApparelSizeGuide extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.openButton = this.querySelector('[data-apparel-size-guide-open]');
      this.modal = this.querySelector('[data-apparel-size-guide-modal]');
      this.drawer = this.querySelector('[role="dialog"]');
      if (!this.openButton || !this.modal || !this.drawer) return;

      this.openButton.addEventListener('click', () => this.open());
      this.querySelectorAll('[data-apparel-size-guide-close]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });
      this.addEventListener('keydown', (event) => this.handleKeydown(event));
      this.querySelectorAll('[data-size-guide-unit]').forEach((button) => {
        button.addEventListener('click', () => this.selectUnit(button.dataset.sizeGuideUnit));
      });
    }

    open() {
      this.modal.hidden = false;
      this.openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('apparel-size-guide-open');
      requestAnimationFrame(() => {
        this.modal.dataset.open = 'true';
        this.drawer.focus({ preventScroll: true });
      });
    }

    close() {
      delete this.modal.dataset.open;
      this.openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('apparel-size-guide-open');
      const finish = () => {
        this.modal.hidden = true;
        this.openButton.focus({ preventScroll: true });
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else window.setTimeout(finish, 300);
    }

    selectUnit(unit) {
      this.querySelectorAll('[data-size-guide-unit]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.sizeGuideUnit === unit));
      });
      this.querySelectorAll('[data-size-guide-table]').forEach((table) => {
        table.hidden = table.dataset.sizeGuideTable !== unit;
      });
    }

    handleKeydown(event) {
      if (this.modal.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...this.modal.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
        .filter((element) => !element.hidden && element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('apparel-size-guide', ApparelSizeGuide);
})();
